import { format } from 'date-fns';
import { Range } from 'react-date-range';

export function toDisplayFormat({ startDate, endDate }: Range, _format: string) {
  if (!startDate && !endDate) return '';

  const map = (date?: Date) => (date ? format(date, _format) : '');
  return [startDate, endDate].map(map).join(' - ');
}
